import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";

const firebaseInstance = firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
});

const firestore = firebaseInstance.firestore();

// Safari — and some corporate proxies — block Firestore's default WebChannel
// streaming transport. The symptom is a console error on the Listen channel
// ("Fetch API cannot load … due to access control checks") and, worse, a
// request that HANGS rather than rejecting: a query .get() never settles, so
// callers sit on a loading state forever. A reload usually works because the
// SDK has by then negotiated a working connection.
//
// Auto-detect probes the connection and falls back to long polling when the
// stream cannot be established. It is the default from firebase v10; this app
// is on 9.10, so it has to be asked for. Must be set before any other
// Firestore call, hence immediately after firestore().
// Guarded: settings() throws if Firestore has already been started, and a
// transport preference is not worth taking the whole app down for.
try {
  firestore.settings({ experimentalAutoDetectLongPolling: true });
} catch (e) {
  console.warn("Firestore settings() rejected; using default transport", e);
}

export const db = firestore;
export const firebaseApp = firebaseInstance;

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
// const { Timestamp, GeoPoint } = firebase.firestore
// export { Timestamp, GeoPoint }

// if using Firebase JS SDK < 5.8.0
// db.settings({ timestampsInSnapshots: true })
